import React from "react";
import "./BeroreAfterGalleryOn.css";

function BeroreAfterGalleryOn(props) {
  const { children } = props;

  return (
    <div className="berore-after-gallery-on">
      <div className="before-after-3 poppins-medium-white-10px">{children}</div>
    </div>
  );
}

export default BeroreAfterGalleryOn;
